export default "__VITE_ASSET__B4vN4r25__"